import {useEffect} from 'react';

import { Link } from 'react-router-dom';
import InventoryManagement from './InventoryManagement';
import PrimaryDistribution from './PrimaryDistribution';
import SecondaryDistribution from './SecondaryDistribution';



const Distributions = () => {
    useEffect(()=>{
        let current_page = window.location.href.split('/').at(-1)
        setTimeout(()=>{
            document.getElementById(`${current_page}`)?.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }, 100)
    })
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            // (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);  
    window.addEventListener("scroll", function(event) {
        let top = this.scrollY,
            window_width = window.innerWidth,
            header_height = document.querySelector("header").style.height+100;
            (top > header_height && window_width > 1024) ? document.querySelector("nav").classList.add('fixed-header-desktop') : document.querySelector("nav").classList.remove('fixed-header-desktop')
            // (top > header_height && window_width > 1024) ? document.querySelector("a").classList.add('fixed-header-desktop') : document.querySelector("a").classList.remove('fixed-header-desktop')
    }, false);   
  
  
    return(
        <div>
            <div id='international' className="distribution-image">
                <img src='/distribution/Distribution-Product-Banner.jpg' alt='' className='w-[100%]'/>
            </div>
            <div className="flex flex-col justify-center gap-4 max-w-[50rem] lg:mx-auto md:mx-auto mx-[2rem]  md:p-[2rem] pt-[1rem] lg:pb-[50px]  pb-[1rem]">
                <p>
                    When customers choose TCS to fulfil their distribution needs, they choose scalability and flexibility 
                    in the form of one of the largest fleets of primary and secondary distribution transportation and strategically 
                    located distribution hubs across the country. TCS Distribution services take into account every relevant factor, 
                    such as inventory, storage spaces and MSDS. Dedicated teams of distribution experts and sales executives make 
                    sure that customers achieve the highest level of satisfaction.
                </p>
                
                
                <div className="MuiFormGroup-root MuiFormGroup-row">
                    <div className="sm:flex grid pb-[50px]">
                        <div className="flex-1 flex flex-col">
                            <div className="flex items-center ">
                                <li><Link to="/distribution/primary-distribution"  className='font-bold'>Primary Distribution</Link></li>
                            </div>
                           
                            <div className="flex items-center">
                                <li><Link to="/distribution/inventory-management" className='font-bold'>Inventory Management</Link></li>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col">
                        <div className="flex items-center">
                                <li><Link to="/distribution/secondary-distribution" className='font-bold'>Secondary Distribution</Link></li>
                            </div>

                            {/* <div className="flex items-center">
                                <li><Link to="/distribution/warehousing" className='font-bold'>Warehousing</Link></li>
                            </div> */}
                        </div>
                            
                    </div>
                </div> 
                
                 
            </div>
            
            <div className='mx-[2rem] md:mx-[0rem]'>
            <div id="primary-distribution">
                <PrimaryDistribution/>
            </div>
            <div id="secondary-distribution">
                <SecondaryDistribution/>
            </div>
            <div id="inventory-management">
                <InventoryManagement/>
            </div>
            </div>
            {/* <div id="warehousing">
                <WareHousing/>
            </div> */}
           
        </div>
    )
};
export default Distributions ;